export default __webpack_public_path__ + "static/media/OliviaPhoto.ef66a126.jpg";